import { render, staticRenderFns } from "./AddFabricantesPage.vue?vue&type=template&id=0a95cd42"
import script from "./AddFabricantesPage.vue?vue&type=script&lang=js"
export * from "./AddFabricantesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports